module.exports = __webpack_public_path__ + "img/rays-seating-map.27f23e57.png";